import React, { useEffect, useReducer, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import styles from 'components/landingpage/assets/TopPage.module.css'
import logo from 'components/landingpage/assets/logo.webp'

export default function () {
  return (
    <React.Fragment>
      <nav className={`${styles.menu}`}>
        <div className={`${styles['menu-nav']}`}>
          <div className={`${styles['menu-logo-box']}`}>
            <Link to="/" className={`${styles['menu-logo']}`}>
              <img
                src={logo}
                className={`${styles['menu-logo-image']}`}
                alt="YOOR"
              />
            </Link>
          </div>
        </div>
      </nav>
    </React.Fragment>
  )
}
